import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CountryCode } from 'typescript/constants/localization';
import ControlledInputPhone from 'typescript/components/forms/controlled_input_phone';
import ControlledInputText from 'typescript/components/forms/controlled_input_text';

const PickupPersonInfoForm = () => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <h3 className="shop-grid-item-full">
        {t('checkout.delivery.pickup.pickupId')}
      </h3>
      <ControlledInputText
        className="shop-grid-item-half"
        control={control}
        name="pickup_first_name"
        label={t('checkout.delivery.addressLabel.firstName')}
      />
      <ControlledInputText
        className="shop-grid-item-half"
        control={control}
        name="pickup_last_name"
        label={t('checkout.delivery.addressLabel.lastName')}
      />
      <ControlledInputText
        className="shop-grid-item-half"
        control={control}
        name="pickup_email"
        label={t('checkout.delivery.addressLabel.email')}
      />
      <ControlledInputPhone
        className="shop-grid-item-half"
        control={control}
        name="pickup_phone"
        label={t('checkout.delivery.addressLabel.phoneNumber')}
        countryCode={CountryCode.US}
      />
    </>
  );
};

export default PickupPersonInfoForm;
